import slidesL144 from './slides_L44';
import { featuresL144 } from './features_L144';
import { ProjectType } from '../../Constants';
import { textL144 } from './text_Local144';

export const L144data = {
    fr: {
        id: 7,
        name: 'Local 144',
        content: textL144.fr,
        yearBuilt: 2019,
        address: "12780, boul. Industriel Pointe-aux-Trembles, Québec, H1A 3V2",
        city: "Montréal",
        brand: "local-144",
        projectPage: "local-144",
        website: "https://www.local144.ca/",
        category: ProjectType.Commercial,
        images: slidesL144,
        features: featuresL144.features_fr
    },
    en: {
        id: 7,
        name: 'Local 144',
        content: textL144.en,
        yearBuilt: 2019,
        address: "12780, boul. Industriel Pointe-aux-Trembles, Québec, H1A 3V2",
        city: "Montréal",
        brand: "local-144",
        projectPage: "local-144",
        website: "https://www.local144.ca/",
        category: ProjectType.Commercial,
        images: slidesL144,
        features: featuresL144.en
    }
    
}